var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOnboardProfileBlueIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5_80)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.5 5C2.5 2.2425 4.7425 0 7.5 0C10.2575 0 12.5 2.2425 12.5 5C12.5 7.7575 10.2575 10 7.5 10C4.7425 10 2.5 7.7575 2.5 5ZM0 15.8333V20H8.33333L8.35667 13.3333C8.42417 12.7217 8.64 12.1542 8.96667 11.6667H4.16667C1.86583 11.6667 0 13.5325 0 15.8333ZM15.8333 17.5H14.1667V16.6667H10V20H20V16.6667H15.8333V17.5ZM17.9167 11.6667H17.5V11.25C17.5 10.5608 16.9392 10 16.25 10H13.75C13.0608 10 12.5 10.5608 12.5 11.25V11.6667H12.0833C10.935 11.6667 10 12.6017 10 13.75V15H20V13.75C20 12.6017 19.065 11.6667 17.9167 11.6667Z",
    fill: "#234492"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5_80"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#234492"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnboardProfileBlueIcon);
export default __webpack_public_path__ + "static/media/onboardProfileBlueIcon.f719472477ae9b94629c96edeb831174.svg";
export { ForwardRef as ReactComponent };